module.exports = __webpack_public_path__ + "assets/media/media.06f8b356.mp4";